import { z } from 'zod';

import { FreddieMacEDRV1 } from '../investorReporting/FreddieMac/FreddieMacEDR';

export const NonPerformanceOccupancyStatus = z.enum([
  'Vacant',
  'Borrower Occupied',
  'Tenant Occupied',
  'Unknown',
  'Abandoned',
  'Occupied by Unknown',
]);
export type NonPerformanceOccupancyStatus = z.infer<typeof NonPerformanceOccupancyStatus>;

export const NonPerformanceOccupancyStatusToFreddieMacEDR: Record<
  NonPerformanceOccupancyStatus,
  FreddieMacEDRV1['occupancyStatus']
> = {
  Vacant: '01',
  'Borrower Occupied': '03',
  'Tenant Occupied': '04',
  Unknown: '06',
  Abandoned: '07',
  'Occupied by Unknown': '15',
};

// TODO find corresponding codes for Fannie Mae's "Default Reporting Application" report
